import { ColumnSetting } from '../../../../../_foundation/models/grid.models';

export const standaloneReadingColumns: ColumnSetting[] = [
  {
    field: 'readingTime',
    title: 'Reading Time',
    filter: 'text',
    filterable: false,
    width: 100
  },
  {
    field: 'actions',
    title: 'Actions',
    width: 80
  }
];



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-log-manage-readings/components/weather-log-standalone-reading-grid/weather-log-standalone-reading.config.ts